export function setOrigenes(state, origenes) {
    state.origenes = origenes;
}

export function setOrigenSelec(state, origen) {
    state.origenSelec = origen;
}

export function actListOrigenes(state, origen) {
    if (origen !== null) {
        const index = state.origenes.findIndex(r => r.id === origen.id)
        if (index != -1) {
            state.origenes[index].nombre = origen.nombre;  
            state.origenes[index].descripcion = origen.descripcion;  
            state.origenes[index].responsable = origen.responsable;  
            state.origenes[index].telefono = origen.telefono;  
            state.origenes[index].email = origen.email;  
            state.origenes[index].grupo_id = origen.grupo_id;  
        }
    }
}

export function actDeleteListOrigenes(state, id) {
    if (id != null) {
        const index = state.origenes.findIndex(r => r.id === id)
        if (index != -1) {
            state.origenes.splice(index, 1)
        }
    }
}


